import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const ClearButton = forwardRef((props, ref) => (
  <BaseButton
    ref={ref}
    iconOnly
    id='clear-button'
    responsive
    fillMode='flat'
    icon='x'
    className='clear-button'
    {...props}
  />
));

ClearButton.displayName = 'ClearButton';

export default ClearButton;
